<template>
  <div v-show="step === 0" class="">
    <div class="mdl-grid">
      <div class="mdl-cell mdl-cell--4-col">
        <div class="mdl-card fill mdl-shadow--2dp ga-tall-card">
          <div class="mdl-tabs mdl-js-tabs">
            <div class="ga-form-title">
              <a href="#details" class="mdl-tabs__tab is-active">{{'newScheduled.label.details' | label}}</a>
              <a href="#faq" class="mdl-tabs__tab">{{'newScheduled.label.faq' | label}}</a>
            </div>
            <div class="mdl-tabs__panel is-active" id="details">
              <scheduled-details></scheduled-details>
            </div>
            <div class="mdl-tabs__panel" id="faq">
              <faq service="scheduled"></faq>
            </div>
          </div>
        </div>
      </div>
      <div class="mdl-cell mdl-cell--4-col">
        <register-form scheduled></register-form>
      </div>
      <div class="mdl-cell mdl-cell--4-col">
        <scheduled-message-form></scheduled-message-form>
      </div>
    </div>
  </div>
  <div v-show="step === 1" class=""  >
    <payment></payment>
  </div>

</template>

<script>
  var api = require('api')
  var local = require('common/store/local')
  module.exports = {
    ready: function () {
      window.componentHandler.upgradeAllRegistered()
    },
    components: {
      scheduledMessageForm: require('c/forms/ScheduledMessageForm'),
      registerForm: require('c/forms/RegisterForm'),
      'scheduled-details': require('c/segments/ScheduledDetails'),
      'faq': require('c/segments/FAQ'),
      alert: require('c/components/Alert'),
      'payment': require('c/pages/Payment')
    },
    methods: {
      onError: function (err) {
        this.$dispatch('show-error', err.data)
      }
    },
    events: {
      'message-valid': function (message) {
        this.message = message
        this.$broadcast('validate-sender')
      },
      'registration-valid': function (user) {
        var self = this
        this.message.userId = this.user.id
        self.$dispatch('loading', true)
        var data = {}
        data.user = user
        data.user.langCode = local.get('client.language') || 'en'
        data.message = self.message
        api.User.createWithMessage(data).then(function (response) {
          self.$dispatch('loading', false)
          var savedUser = response.data
          savedUser['service'] = 'SCHEDULED'
          self.$broadcast('pay', savedUser)
          self.step = 1
        }, self.onError)
        // auth.register(user, function (user) {
        //   self.user = user
        //   self.user['service'] = 'SCHEDULED'
        //   self.message.userId = user.id
        //   api.MessageModel.save(self.message).then(function () {
        //     self.$dispatch('loading', false)
        //     self.$broadcast('pay', self.user)
        //     self.step = 1
        //   }, self.onError)
        // }, self.onError)
      }
    },
    data: function () {
      return {
        step: 0,
        user: {},
        message: {},
        token: ''
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// NewScheduled.vue?734736b2